import { useState, useEffect } from "react";

export const useChangeThemeStyles = (
  theme: string | undefined,
  lightStyle: string,
  darkStyle: string
) => {
  const [themeStyle, setThemeStyle] = useState("");
  useEffect(() => {
    setThemeStyle(theme === "light" ? lightStyle : darkStyle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return { themeStyle };
};
